var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: {
        "d-flex": _vm.horizontal,
        "justify-content-between": _vm.horizontal,
      },
    },
    [
      _c(
        "label",
        { class: _vm.customLabelClass, attrs: { id: _vm.customLabelId } },
        [
          _vm._v("\n    " + _vm._s(_vm.inputLabel) + "\n    "),
          _vm.statusIcon !== ""
            ? _c("i", {
                staticClass: "icon icon-transaction-detail",
                class: _vm.statusIcon,
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.tooltipLabel
            ? _c("i", {
                staticClass:
                  "fa-duotone fa-circle-info cursor text-info tooltipIcon",
                attrs: { title: _vm.tooltipLabel },
              })
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "inputParentFormReadGroup",
          class: _vm.customInputClass,
        },
        [
          _vm.inputType === "textarea"
            ? _c(
                "textarea",
                {
                  staticClass: "form-control inputAccordionForm resize-none",
                  attrs: { disabled: "" },
                },
                [_vm._v(_vm._s(_vm.inputValue))]
              )
            : _c(
                "span",
                {
                  staticClass: "inputTextFormReadGroup",
                  attrs: { id: _vm.customInputId, title: _vm.inputValue },
                },
                [_vm._v(_vm._s(_vm.inputValue))]
              ),
          _vm._v(" "),
          _vm._t("afterInput"),
        ],
        2
      ),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }